const colores: Record<string, string> = {
  verde: "bg-emerald-50 text-emerald-700",
  amarillo: "bg-amber-50 text-amber-700",
  rojo: "bg-red-50 text-red-700",
  azul: "bg-sky-50 text-sky-700",
  gris: "bg-slate-100 text-slate-600",
  morado: "bg-violet-50 text-violet-700",
};

export function Badge({ children, color = "gris" }: { children: React.ReactNode; color?: keyof typeof colores }) {
  return <span className={`badge ${colores[color]}`}>{children}</span>;
}
